import { GetPositionArgs } from "..";
import { Align } from "../types";

export function getPosition({
  align,
  alignOffset,
  anchorRef,
  contentRef,
  offset,
  side,
}: GetPositionArgs) {
  if (!anchorRef.current || !contentRef.current) return null;
  const position = anchorRef.current.getBoundingClientRect();
  const contentRect = contentRef.current;
  const width = contentRect.offsetWidth;
  const height = contentRect.offsetHeight;

  if (side === "bottom") {
    return {
      left:
        position.left +
        getHorizontalAlignmentOffset(align, width, position.width) +
        alignOffset,
      top: position.bottom + offset,
    };
  }

  if (side === "left") {
    return {
      left: position.left - width - offset,
      top:
        position.top +
        getVerticalAlignmentOffset(align, height, position.height) +
        alignOffset,
    };
  }

  if (side === "right") {
    return {
      left: position.right + offset,
      top:
        position.top +
        getVerticalAlignmentOffset(align, height, position.height) +
        alignOffset,
    };
  }

  return {
    left:
      position.left +
      getHorizontalAlignmentOffset(align, width, position.width) +
      alignOffset,
    top: position.top - height - offset,
  };
}

function getHorizontalAlignmentOffset(
  align: Align,
  tooltipWidth: number,
  targetWidth: number,
): number {
  switch (align) {
    case "center":
      return (targetWidth - tooltipWidth) / 2;
    case "end":
      return targetWidth - tooltipWidth + 18;
    case "start":
    default:
      return -18;
  }
}

function getVerticalAlignmentOffset(
  align: Align,
  tooltipHeight: number,
  targetHeight: number,
): number {
  switch (align) {
    case "center":
      return (targetHeight - tooltipHeight) / 2;
    case "end":
      return targetHeight - tooltipHeight + 8;
    case "start":
      return -8;
  }
}
